import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaEventService } from '../../../services/ga-event.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { FormattingService } from '../../../services/formatting.service';
import { ILov, IObject } from '../../../../../type_definitions/datatypes';
import { ReportDataService } from '../../report-data.service';

@Component({
  selector: 'batch-billing-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class BatchBillingActionComponent extends BaseReportActionsDialog implements OnInit {
  private batchBillField: IExtraFieldConfigurationObject;
  private subjectField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private formattingService: FormattingService,
    private reportDataService: ReportDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      batchBill: undefined
    };

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.batchBillField = this.formlyService.aSelect('batchBill', 'Select batch bill')
        .isRequired()
        .withFormat(this.formattingService.formatLov)
        .onChange(this.batchBillOnChange)
        .build(),
      this.subjectField = this.formlyService.aTextarea('subject', 'Subject')
        .isHide()
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(this.batchBillField, this.reportDataService.loadReportActionInfo(this.reportId, this.action.id, this.rowSelection, true)
      .then((actionInfoData) => {
        if (actionInfoData.info?.length === 1 && actionInfoData.info[ 0 ].id === -1) {
          this.form.patchValue({ batchBill: actionInfoData.info[ 0 ] });
          // trigger onChange
          this.batchBillOnChange(this.model.batchBill);
        }

        return actionInfoData.info;
      })
      .catch((data:IObject) => {
        this.error = data?.message;
        this.updateButtonStatus();
      }));
  }

  private batchBillOnChange = (batchBill: ILov): void => {
    // hide subject field when expected option selected
    this.subjectField.hide = batchBill.value !== 'Create new batch bill';
    // clear subject model when option change
    this.form.patchValue({ subject: undefined });
  };
}